import AllCheckBox from "@/components/Explore/Pubmed/Content/AllCheckBox";
import FixedWidget from "@/components/FixedWidget";
import { useCart } from "@/hooks/useCart";
import useTranslation from "@/hooks/useTranslation";
import { cartSelectedIdsState, cartState } from "@/stores/cart";
import { ShoppingCartOutlined } from "@ant-design/icons";
import {
  Fade,
  IconButton,
  List,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { TransitionProps } from "@material-ui/core/transitions";
import FullscreenIcon from "@material-ui/icons/Fullscreen";
import { Avatar, Spin } from "antd";
import Link from "next/link";
import React, { useEffect, useState } from "react";
import { useRecoilState, useRecoilValue } from "recoil";
import AddList from "./components/AddList";
import DeleteButton from "./components/DeleteButton";
import ItemList from "./components/ItemList";
import styles from "./styles.module.less";

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & { children?: React.ReactElement },
  ref: React.Ref<unknown>
) {
  return <Fade ref={ref} {...props} />;
});

const AlterCollectionCard: React.FC = () => {
  const { loading, getCart } = useCart();

  const cart = useRecoilValue(cartState);

  const { papers } = cart;

  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const [ids, _setIds] = useRecoilState(cartSelectedIdsState);

  const setIds = (ids: string[]) => _setIds(ids);

  const handleToggle = (id: string) => {
    if (ids.includes(id)) {
      setIds(ids.filter((_id) => _id !== id));
    } else {
      setIds([...new Set([...ids, id])]);
    }
  };

  const { t } = useTranslation("bundle");

  const [menuOpen, setMenuOpen] = useState(false);

  const handleClick = () => setMenuOpen(true);

  const handleMenuClose = () => setMenuOpen(false);

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

  useEffect(() => {
    getCart();
  }, []);

  return (
    <FixedWidget zIndex={open ? 0 : 9999}>
      <div onClick={handleClickOpen}>
        <Avatar icon={<ShoppingCartOutlined />} className={styles.icon} />
      </div>
      <Dialog
        open={open}
        onClose={handleClose}
        className={styles.sa}
        fullScreen={fullScreen}
        scroll="paper"
        TransitionComponent={Transition}
      >
        <DialogTitle>
          <div className={styles.flex}>
            <AllCheckBox
              pmids={papers.map((paper) => paper?.id)}
              ids={ids}
              setIds={setIds}
              verbose
            />
            {t("cart.itself")} <DeleteButton ids={ids} />
            <Link href="/bundle/cart">
              <IconButton>
                <FullscreenIcon />
              </IconButton>
            </Link>
          </div>
        </DialogTitle>
        <DialogContent>
          <DialogContentText>{t("cart.des")}</DialogContentText>
          <Fade in={open}>
            <Spin spinning={loading}>
              <List>
                {papers.map((paper, index) => {
                  return (
                    <ItemList
                      key={paper?.id}
                      paper={paper}
                      index={index}
                      ids={ids}
                      handleToggle={handleToggle}
                    />
                  );
                })}
              </List>
            </Spin>
          </Fade>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="default">
            {t("common:cancel")}
          </Button>
          <Button onClick={handleClick} color="primary">
            {t("cart.add.to-collection")}
          </Button>
          <AddList menuOpen={menuOpen} handleMenuClose={handleMenuClose} />
        </DialogActions>
      </Dialog>
    </FixedWidget>
  );
};

export default AlterCollectionCard;
